<mat-tab-group>

  <mat-tab >
    <ng-template mat-tab-label>
    <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">

    Badges Exposants
  </ng-template>
    <app-badges-exposant></app-badges-exposant>

  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">

      Badges Visiteurs
    </ng-template>
    <app-badges-visiteur></app-badges-visiteur>
  </mat-tab>


</mat-tab-group>